import { TableCell, TableRow } from "@/components/ui/table";

interface EacHoursBasedRowProps {
  hours: number;
}

/** Budget vs Actual row showing the HTC-based EAC hours projection. */
export function EacHoursBasedRow({ hours }: EacHoursBasedRowProps) {
  return (
    <TableRow className="bg-muted/30">
      <TableCell className="text-muted-foreground pl-6 text-sm">
        EAC (Hours-based)
        <span className="ml-1.5 text-xs text-muted-foreground/70">HTC projection</span>
      </TableCell>
      <TableCell className="text-right text-muted-foreground">—</TableCell>
      <TableCell className="text-right text-muted-foreground">—</TableCell>
      <TableCell className="text-right text-muted-foreground">—</TableCell>
      <TableCell className="text-right text-muted-foreground">—</TableCell>
      <TableCell className="text-right text-muted-foreground">
        {`${hours.toLocaleString()}h`}
      </TableCell>
    </TableRow>
  );
}
